export const FOUNDATION_PRINCIPAL =
	"wts6q-bwcvn-h7sno-bmuez-ckuay-fahc4-z37yh-qemtr-berff-4a3sw-vae";

export interface SponsoredToken {
	id: string;
	name: string;
	ticker: string;
	description: string;
	customCopyZh?: string;
	customCopyEn?: string;
	image: string;
	price: number;
	total_supply: number;
	divisibility?: number;
	decimals?: number;
	twitter?: string;
	website?: string;
	telegram?: string;
}

export interface SponsoredHolding {
	balance: number;
	price: number;
	unrealized_pnl?: number;
	unrealized_pnl_percent?: number;
	supportAgeDays?: number;
	token: SponsoredToken;
}

export interface SponsoredRankingResponse {
	data: SponsoredHolding[];
	page: number;
	limit: number;
	count: number;
}

export interface SponsoredCopyItem {
	tokenId: string;
	copy: string;
	copyEn?: string;
	enabled?: boolean;
}

export interface SponsoredCopyConfig {
	version: number;
	updatedAt: string;
	items: SponsoredCopyItem[];
}
